// SHIM: remove in retire-legacy-test-harness
// Synchronous parse callers disappear with their owning service/host ports.
import { Result, Schema } from "effect";
import { ContractDecodeError } from "./errors/validation.ts";

const decodeFailure = (error: Schema.SchemaError) => new ContractDecodeError({ message: error.message });

/** Private decoder facades do not attach methods to shared Schema objects. */
export function schemaDecoder<S extends Schema.ConstraintDecoder<unknown>>(
  schema: S,
  onError: (error: Schema.SchemaError) => unknown = decodeFailure
) {
  const decode = Schema.decodeUnknownResult(schema);
  return {
    parse: (input: unknown): S["Type"] => Result.getOrThrowWith(decode(input), onError),
    safeParse: (input: unknown) => Result.match(decode(input), {
      onSuccess: data => ({ success: true as const, data }),
      onFailure: error => ({ success: false as const, error: onError(error) })
    })
  };
}

export function schemaParser<S extends Schema.ConstraintDecoder<unknown>>(
  schema: S,
  onError: (error: Schema.SchemaError) => unknown = decodeFailure
) {
  const decode = Schema.decodeUnknownResult(schema);
  return (input: unknown): S["Type"] => Result.getOrThrowWith(decode(input), onError);
}

/** Retained only where a caller still consumes the combined Schema facade. */
export function defineSchema<S extends Schema.ConstraintDecoder<unknown>>(
  schema: S,
  onError: (error: Schema.SchemaError) => unknown = decodeFailure
) {
  return Object.assign(schema, schemaDecoder(schema, onError));
}
